export const ROUTES = {
  ADMIN_ROOT: '/admin',
  CLIENT_LOGIN: '/login',
  ADMIN_LOGIN: '/admin/login',
  CLIENT_HOME: '/dashboard',
  ADMIN_HOME: '/admin/dashboard',
  CLIENT_PROFILE: '/profile',
  ADMIN_PROFILE: '/admin/profile',
  CRASH: '/sorry'
}

export const WHITE_LIST_PAGE = [
  '/admin',
  '/login',
  '/admin/login',
  '/profile',
  '/admin/profile',
  '/sorry',
  '/brandManagement'
]
